import { type FC } from 'react'

interface SectionDividerProps {
  label: string
  className?: string
}

const SectionDivider: FC<SectionDividerProps> = ({
  label,
  className = 'my-4',
}) => (
  <div className={`flex justify-center ${className}`}>
    <span className="px-3 py-1 rounded-full text-pearl/70 text-[11px] tracking-wide font-medium bg-charcoal/70 backdrop-blur-md shadow-[0_1px_2px_rgba(20,17,11,0.04)] border border-pearl/8">
      {label}
    </span>
  </div>
)

export default SectionDivider
